const menutrans = {
  title: {
    english: "Barzegar",
    persian: "برزگر",
    icon: "fa-eercast",
    href: "http://barzegargold.com/",
  },
  menu: [
    {
      english: "OverView",
      persian: "OverView",
      index: 0,
      icon: "fa-dashboard",
      href: "#",
      children: [
        {
          english: "Orders Managment",
          persian: "مدیریت سفارشات",
          index: 1,
          icon: "fa-bar-chart",
          href: "/crm",
          url: "crm",
        },
      ],
    },
    {
      english: "Customers",
      persian: "مشتریان",
      index: 1,
      icon: "fa-users",
      href: "#",
      children: [
        {
          english: "Customers",
          persian: "مدیریت مشتریان",
          index: 0,
          icon: "fa-users",
          href: "/customers",
          url: "customers",
        },
        {
          english: "Messages",
          persian: "پیام ها",
          index: 0,
          icon: "fa-envelope",
          href: "/CutomerMessages",
          url: "CutomerMessages",
        },
        {
          english: "Comments",
          persian: "کامنت ها",
          index: 0,
          icon: "fa-comment",
          href: "/CutomerComments",
          url: "CutomerComments",
        },
      ],
    },
    {
      english: "Orders",
      persian: "سفارشات",
      index: 2,
      icon: "fa-tasks",
      href: "#",
      children: [
        {
          english: "Orders",
          persian: "سفارشات",
          index: 0,
          icon: "fa-tasks",
          href: "/orders",
          url: "orders",
        },
        {
          english: "Sales Analyze",
          persian: "آنالیز فروش",
          index: 0,
          icon: "fa-bar-chart",
          href: "/visitor",
          url: "visitor",
        },
      ],
    },

    {
      english: "Products",
      persian: "محصولات و خدمات",
      index: 3,
      icon: "fa-bar-chart",
      href: "#",
      children: [
        {
          english: "Products",
          persian: "محصولات",
          index: 0,
          icon: "fa-dashboard",
          href: "/products",
          url: "products",
        },
        {
          english: "Shemsh",
          persian: "شمش",
          index: 0,
          icon: "fa-dashboard",
          href: "/shemsh",
          url: "shemsh",
        },
        {
          english: "Category",
          persian: "دسته بندی ها",
          index: 1,
          icon: "fa-bar-chart",
          href: "/category",
          url: "category",
        },
      ],
    },
    {
      english: "Configuration",
      persian: "تنظیمات",
      index: 0,
      icon: "fa-dashboard",
      href: "#",
      children: [
        {
          english: "Sales Parameters",
          persian: "پارامترهای فروش",
          index: 0,
          icon: "fa-percent",
          href: "/SaleSetting",
          url: "config",
        },
        {
          english: "News",
          persian: "خبرها",
          index: 0,
          icon: "fa-newspaper-o",
          href: "/news",
          url: "news",
        },
        {
          english: "Sliders",
          persian: "اسلایدرها",
          index: 0,
          icon: "fa-dashboard",
          href: "/sliders",
          url: "sliders",
        },
        {
          english: "Stories",
          persian: "استوری ها",
          index: 0,
          icon: "fa-dashboard",
          href: "/Story",
          url: "Story",
        },
        {
          english: "Gallery",
          persian: "گالری",
          index: 0,
          icon: "fa-dashboard",
          href: "/gallery",
          url: "gallery",
        },
        {
          english: "Faq",
          persian: "سوالات متداول",
          index: 0,
          icon: "fa-dashboard",
          href: "/faq",
          url: "faq",
        },
        {
          english: "Blog",
          persian: "مقالات ",
          index: 0,
          icon: "fa-newspaper-o",
          href: "/Blog",
          url: "Blog",
        },
        {
          english: "Update",
          persian: "بروزرسانی",
          index: 0,
          icon: "fa-dashboard",
          href: "/update",
          url: "update",
        },

        {
          english: "Upload",
          persian: "آپلود مدیا ",
          index: 0,
          icon: "fa-dashboard",
          href: "/Upload",
          url: "Upload",
        },
      ],
    },
  ],
  setting: [
    {
      english: "Access",
      persian: "دسترسی ها",
      index: 0,
      icon: "fa-key",
      href: "/access",
      url: "access",
    },
    {
      english: "Filters",
      persian: "فیلترها",
      index: 1,
      icon: "fa-key",
      href: "/filter",
      url: "filter",
    },

    {
      english: "User Management",
      persian: "مدیریت کاربران",
      index: 0,
      icon: "fa-user",
      href: "/users",
      url: "users",
    },
    {
      english: "Documents",
      persian: "مستندات",
      index: 1,
      icon: "fa-learn",
      href: "/documents/list",
      url: "documents",
    },
  ],
};
export default menutrans;
